import React from "react";
import { FaX } from "react-icons/fa6";
import styles from "./playVideoModal.module.css";

const PlayVideoModal = ({ open, onClose, video }) => {
  const youtubeId = video?.youtube_video_id || video?.youtubeId || video?.youtube_video;
  if (!open || !youtubeId) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>{video.title}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <FaX />
          </button>
        </div>
        <div className={styles.playerWrapper}>
          <iframe
            className={styles.iframe}
            src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default PlayVideoModal;